import { UserInfo } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';
import { ADD_DASHBOARD_COLLABORATOR_PARAM } from '../constants';

interface GetRequestDashboardAccessLinkOptions {
  dashboardLink: string;
}

export const useGetRequestDashboardAccessLink = ({
  dashboardLink,
}: GetRequestDashboardAccessLinkOptions) => {
  const user = useGetUser();

  const userInfo: UserInfo = {
    id: user.id,
    firstName: user.firstName,
    lastName: user.lastName,
  };

  const unencodedJSON = JSON.stringify(userInfo);
  const uriComponent = encodeURIComponent(unencodedJSON);
  const base64JSON = window.btoa(uriComponent);

  const params = new URLSearchParams();
  params.append(ADD_DASHBOARD_COLLABORATOR_PARAM, base64JSON);

  return `${dashboardLink}?${params.toString()}`;
};
